export const SCHEDULE_EVENT_FILTER_KEY = 'scheduleEventFilterKey';

export const SCHEDULE_EVENT_FILTER_OPTIONS = [
    {
        key: 'All',
        value: 'all'
    },
    {
        key: 'Requested',
        value: 'invited'
    },
    {
        key: 'Booked',
        value: 'booked'
    },
    {
        key: 'Reserved',
        value: 'reserved'
    },
    {
        key: 'Rejected',
        value: 'rejected'
    },
    {
        key: 'Accepted',
        value: 'accepted'
    },


]

export const schedulesEmployeeActionStatus = {
    rejected: 'rejected',
    accepted: 'accepted',
    pending: 'pending',
    partial: 'partial',
}